import styled from 'styled-components';
import { Button } from '@xingternal/button';
import { scale150, spaceM, xdlColorControlFillSecondary, xdlColorControlFillTertiary, xdlColorText, } from '@xingternal/tokens';
import { mediaConfined } from '@xingternal/layout-tokens';
export const NotificationCenterButton = styled(Button) `
  border-radius: ${scale150};

  &:hover {
    background-color: ${xdlColorControlFillSecondary};
  }

  &:active {
    background-color: ${xdlColorControlFillTertiary};
    border-color: ${xdlColorControlFillTertiary};
    color: ${xdlColorText};
  }

  @media ${mediaConfined} {
    display: inline-flex;
    height: 56px;
    padding-left: ${spaceM};
    padding-right: ${spaceM};
  }

  /* InnerContent */
  & > div {
    flex-direction: column;

    & > span:nth-child(2) {
      display: none;

      @media ${mediaConfined} {
        display: flex;
      }
    }
    & > span {
      /* Icon */
      &:nth-child(1) {
        margin-right: 0;
      }
      /* Text */
      &:nth-child(2) {
        @media ${mediaConfined} {
          align-items: center;
          display: flex;
          flex-direction: column;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
  }
`;
//# sourceMappingURL=NotificationCenter.styles.js.map